import type { CustomerRow } from '../../customerops/framework';

type Props = { customers?: CustomerRow[] };

export function CustomerIntelligenceCard({ customers = [] }: Props) {
  return (
    <div className="space-y-3">
      {customers.map((c) => (
        <div key={c.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between">
            <p className="font-medium">{c.name}</p>
            <p className="text-sm font-semibold text-brand-600">{c.ltv} LTV</p>
          </div>
          <div className="mt-2 flex gap-4 text-xs text-slate-500">
            <span>{c.orders} orders</span>
            <span>Repeat: {c.repeatScore}%</span>
            <span>Loyalty: {c.loyaltyScore}%</span>
          </div>
        </div>
      ))}
    </div>
  );
}
